
type ShippingCarrier = {
  name: string;
  code: string;
  externalMappings: {
    ebay?: {
      carrierCode: string;
    };
    leboncoin?: {
      carrierCode: string;
    };
    temu?: {
      logisticsServiceProviderId: number;
    };
  };
}

export type ShippingCarrierCode = (
  'aliexpress'
  | 'chronopost'
  | 'dpd'
  | 'mondial_relay'
  | 'relais_colis'
  | 'colissimo'
  | 'ups'
);

export const ShippingCarriers = {
  aliexpress: {
    name: 'Aliexpress',
    code: 'aliexpress',
    externalMappings: {
      ebay: {
        carrierCode: 'Cainiao',
      },
      leboncoin: {
        carrierCode: 'Cainiao Global',
      }
    }
  },

  chronopost: {
    name: 'Chronopost',
    code: 'chronopost',
    externalMappings: {
      ebay: {
        carrierCode: 'Chronopost',
      },
      leboncoin: {
        carrierCode: 'shop2shop',
      }
    }
  },

  dpd: {
    name: 'DPD',
    code: 'DPD',
    externalMappings: {
      ebay: {
        carrierCode: 'DPD',
      },
    }
  },

  mondial_relay: {
    name: 'Mondial Relay',
    code: 'mondial_relay',
    externalMappings: {
      ebay: {
        carrierCode: 'Mondial Relay',
      },
      leboncoin: {
        carrierCode: 'mondial_relay',
      }
    }
  },

  relais_colis: {
    name: 'Relais Colis',
    code: 'relais_colis',
    externalMappings: {
      leboncoin: {
        carrierCode: 'relais_colis_dropoff',
      }
    }
  },

  colissimo: {
    name: 'Colissimo',
    code: 'colissimo',
    externalMappings: {
      leboncoin: {
        carrierCode: 'colissimo',
      }
    }
  },

  ups: {
    name: 'UPS',
    code: 'ups',
    externalMappings: {
      ebay: {
        carrierCode: 'UPS',
      },
      temu: {
        logisticsServiceProviderId: 314439762,
      },
    }
  },

  fedex: {
    name: 'Fedex',
    code: 'fedex',
    externalMappings: {
    }
  }
} as const;

export const ShippingCarriers_byEbayCarrierCode = Object.fromEntries(
  Object.values(ShippingCarriers)
    .filter(carrier => !!carrier.externalMappings.ebay)
    .map(
      carrier => [carrier.externalMappings.ebay!.carrierCode, carrier]
    )
);

export const ShippingCarriers_byLeboncoinCarrierCode = Object.fromEntries(
  Object.values(ShippingCarriers)
    .filter(carrier => !!carrier.externalMappings.leboncoin)
    .map(
      carrier => [carrier.externalMappings.leboncoin!.carrierCode, carrier]
    )
);

export const ShippingCarriers_byTemuCarrierCode = Object.fromEntries(
  Object.values(ShippingCarriers)
    .filter(carrier => !!carrier.externalMappings.temu)
    .map(
      carrier => [carrier.externalMappings.temu!.logisticsServiceProviderId, carrier]
    )
);


export const ShippingCarriers_byPlatformAndCarrierCode = {
  ebay: ShippingCarriers_byEbayCarrierCode,
  leboncoin: ShippingCarriers_byLeboncoinCarrierCode,
  temu: ShippingCarriers_byTemuCarrierCode,
}